<template>
  <v-layout row wrap>
		
		<v-flex xs12>
			<v-card color="secondary">
				<v-card-text>
					<v-layout
						align-center
						justify-center
						wrap
					>
						<v-flex v-if="userRole == 'admin' && beta" xs12 md3 pa-1 class="text-xs-center">
							<MiniStatistic
								icon="trending_up"
								:title="holder"
								subTitle="Orders"
								color="primary"
							/>
						</v-flex>
						<v-flex v-if="userRole == 'admin' && beta" xs12 md3 pa-1 class="text-xs-center">
							<MiniStatistic
								icon="shopping_cart"
								:title="holder"
								subTitle="USD"
								color="success"
							/>
						</v-flex>
						<v-flex v-if="userRole == 'admin' && beta" xs12 md3 pa-1 class="text-xs-center">
							<MiniStatistic
								icon="done_all"
								:title="holder"
								subTitle="%"
								color="primary"
							/>
						</v-flex>
						<v-flex v-if="userRole == 'admin' && beta" xs12 md3 pa-1 class="text-xs-center">
							<MiniStatistic
								icon="shopping_basket"
								:title="holder"
								subTitle="USD"
								color="primary"
							/>
						</v-flex>
						<v-flex xs12 class="text-xs-center" mt-1 pa-1>
							<v-text-field
								label="Search"
								solo
								hide-details
								clearable
								v-model="searchTerm"
								@input="filterCampaigns()"
							>
							</v-text-field>
						</v-flex>
						<v-flex v-if="userRole == 'admin'" xs12 md3 pa-1 class="text-xs-center">
							<v-btn @click="addCampaign()" color="primary" dark large>Add New campaigns
								<v-icon right>timeline</v-icon>
							</v-btn>
						</v-flex>
						<v-flex xs12>
							<v-btn 
								@click="addCampaign()" 
								fab 
								absolute 
								left 
								top 
								small
								color="primary" 
								dark
							>
								<v-icon>add</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-flex xs12 sm12 md12 py-2>
			<div class="text-xs-center">
				<div><v-chip v-if="!loading" color="success" text-color="white">
					{{filteredCampaigns ? filteredCampaigns.length : 0}} results  
					</v-chip></div>
					<v-pagination
						v-model="currentPage"
						:length="pagesNumber"
						:total-visible="5"
						@input="updateVisible"
					></v-pagination>
				</div>
		</v-flex>
		<v-flex xs12 pa-3>
			<v-layout row wrap align-center>
				<v-flex v-for="c in visibleCampaigns" :key="c.token" xs12 pa-1>
					<v-card class="pa-2 elevation-4">
						<v-layout row wrap >
							<v-flex xs12>
								<div class="caption grey--text ">Campain Name</div>
								<v-tooltip top>
									<span slot="activator">{{ c.name }}
										<v-btn color="primary" 
                    	flat 
											v-clipboard:copy="c.name"
											v-clipboard:success="clipboardSuccessHandler"
											v-clipboard:error="clipboardErrorHandler"
											icon 
											class="ma-0"
											small>
												<v-icon size="15">file_copy</v-icon>
										</v-btn>
									</span>
									<span>{{ c.name }}</span>
								</v-tooltip>
							</v-flex>
							<v-flex v-if="c.token" xs4 md2>
								<div class="caption grey--text ">Token</div>
								<v-tooltip top>
									<span slot="activator">{{ c.token }}
										<v-btn color="primary" 
                    	flat 
											v-clipboard:copy="c.token"
											v-clipboard:success="clipboardSuccessHandler"
											v-clipboard:error="clipboardErrorHandler"
											icon 
											small>
												<v-icon size="15">file_copy</v-icon>
										</v-btn>
									</span>
									<span>{{ c.token }}</span>
								</v-tooltip>
							</v-flex>
							<v-flex v-if="c.campaignid" xs4 md2>
								<div class="caption grey--text ">Campaign ID</div>
								<v-tooltip top>
									<span slot="activator">{{ c.campaignid }}
										<v-btn color="primary" 
                    	flat 
											v-clipboard:copy="c.campaignid"
											v-clipboard:success="clipboardSuccessHandler"
											v-clipboard:error="clipboardErrorHandler"
											icon 
											small>
												<v-icon size="15">file_copy</v-icon>
										</v-btn>
									</span>
									<span>{{ c.campaignid }}</span>
								</v-tooltip>
							</v-flex>
							<v-flex v-if="c.companycode" xs4 md2>
								<div class="caption grey--text ">Company Code</div>
								<v-tooltip top>
									<span slot="activator">{{ c.companycode }}
										<v-btn color="primary" 
                    	flat 
											v-clipboard:copy="c.companycode"
											v-clipboard:success="clipboardSuccessHandler"
											v-clipboard:error="clipboardErrorHandler"
											icon 
											small>
												<v-icon size="15">file_copy</v-icon>
										</v-btn>
									</span>
									<span>{{ c.companycode }}</span>
								</v-tooltip>
							</v-flex>
							<v-flex v-if="c.source" xs4 md1>
								<div class="caption grey--text ">Source</div>
								<v-tooltip top>
									<span slot="activator">{{ c.source | truncate(5, (c.source.length>8 ? '..': '' ))  }}
										<v-btn color="primary" 
                    	flat 
											v-clipboard:copy="c.source"
											v-clipboard:success="clipboardSuccessHandler"
											v-clipboard:error="clipboardErrorHandler"
											icon 
											small>
												<v-icon size="15">file_copy</v-icon>
										</v-btn>
									</span>
									<span>{{ c.source }}</span>
								</v-tooltip>
							</v-flex>
							<v-flex xs4 md1>
								<div class="caption grey--text ">Leads</div>
								<v-tooltip top>
									<span slot="activator">{{ c.leads }}</span>
									<span>{{ c.leads }} Leads | {{ c.clicks }} Clicks</span>
								</v-tooltip>
							</v-flex>
							<v-flex v-if="c.total" xs4 md1>
								<div class="caption grey--text ">Revenue</div>
								<v-tooltip top>
									<span slot="activator">${{ getTotal(c.total) }}</span>
									<span>${{ getTotal(c.total) }} in total revenue</span>
								</v-tooltip>
							</v-flex>
							<v-flex xs4 md1>
								<div class="caption grey--text ">Active</div>
								<v-tooltip v-if="!c.last" top>
									<span slot="activator">
										<v-progress-circular size="12" indeterminate color="primary"></v-progress-circular>
									</span>
									<span>Campaign waiting first click</span>
								</v-tooltip>
								<v-tooltip v-if="c.last && compareDate(c)" top>
									<span slot="activator">
										<v-icon size="18" color="primary">done</v-icon>
									</span>
									<span>Campaign active | Last Visit {{ new Date(c.last).toLocaleString('en-GB') }}</span>
								</v-tooltip>
							</v-flex>
							<v-flex xs2>
								<v-layout row wrap>
									<v-flex v-if="c" xs4 md4 class="text-xs-center">
										<v-tooltip top>
											<span slot="activator">
												<v-btn @click="dialogs.delete = true"  color="error" icon flat>
													<v-icon>close</v-icon>
												</v-btn>
											</span>
											<span>Delete {{ c.token }}</span>
										</v-tooltip>
										<v-dialog v-model="dialogs.delete" persistent max-width="390">
											<v-card>
												<v-card-title class="headline">Are You Sure?</v-card-title>
												<v-card-text>
													You are about to delete campaign: {{ c.name }}, are you sure you want to do that?
													<div class="error white--text pa-2 ma-3">NOTE: all data associated with {{ c.name }} will be deleted completely from our servers, and it will be impossible to restore it</div>
												</v-card-text>
												<v-card-actions>
													<v-spacer></v-spacer>
													<v-btn color="success" @click="dialogs.delete = false">cancel</v-btn>
													<v-btn 
														color="error" 
														outline 
														@click="deleteB(c)"
													>confirm</v-btn>
												</v-card-actions>
											</v-card>
										</v-dialog>
									</v-flex>
									<v-flex v-if="c" xs4 md4 class="text-xs-center">
										<v-tooltip top>
											<span slot="activator">
												<v-btn @click="duplicate(c)"  color="primary" icon flat>
													<v-icon>file_copy</v-icon>
												</v-btn>
											</span>
											<span>Duplicate {{ c.token }}</span>
										</v-tooltip>
									</v-flex>
									<v-flex v-if="c" xs4 md4 class="text-xs-center">
										<v-tooltip top>
											<span slot="activator">
												<v-btn @click="selectForEditing(c)"  color="primary" icon flat>
													<v-icon>edit</v-icon>
												</v-btn>
											</span>
											<span>Edit: {{ c.token }}</span>
										</v-tooltip>
									</v-flex>
								</v-layout>
							</v-flex>
							<v-flex xs12>
								<v-card pa-3>
									<v-expansion-panel expand>
										<v-expansion-panel-content>
											<div slot="header">Stats</div>
											<v-card>
												<v-card-text>
													<v-layout class="secondary white--text text-xs-center" pa-2 row wrap>
														<v-flex xs4>
															Total Revenue: ${{c.total}}
														</v-flex>
														<v-flex xs4>
															Clicks: {{c.clicks}}
														</v-flex>
														<v-flex xs4>
															Leads: {{c.leads}}
														</v-flex>
													</v-layout>
													<v-layout v-if="c.stats" row wrap>
														<v-flex xs12 class="title" py-1>
															Detailed Totals
														</v-flex>
														<v-flex v-if="c.daily" xs12 py-1>
															Daily Totals
														</v-flex>
														<v-flex v-if="c.daily" xs12 pb-2>
															<v-layout row wrap>
																<v-flex xs12 v-for="(dkey, o) in Object.keys(c.daily)" :key="o+c.token+dkey">
																	<v-layout row wrap>
																		<v-flex xs6>
																		</v-flex>
																		<v-flex xs2>
																			{{dkey.replace(/_/g, ' ').toUpperCase()}}:
																		</v-flex>
																		<v-flex xs2>
																			${{c.daily[dkey]}}
																		</v-flex>
																		<v-flex v-if="c.leadsDaily" xs2>
																			Leads: {{c.leadsDaily[dkey]}}
																		</v-flex>
																	</v-layout>
																</v-flex>
															</v-layout>
														</v-flex>
														<v-flex xs12 v-for="(key, n) in Object.keys(c.stats)" :key="n+c.token+key">
															<v-layout row wrap>
																<v-flex xs6>
																	{{key.replace(/_/g, ' ').toUpperCase()}}:
																</v-flex>
																<v-flex v-if="typeof c.stats[key] != 'object'" xs6 class="font-weight-bold">
																	${{c.stats[key]}}
																</v-flex>
																<v-flex v-if="typeof c.stats[key] == 'object'" xs6 class="font-weight-bold">
																	<v-layout row wrap>
																		<v-flex v-for="skey in Object.keys(c.stats[key])" :key="n+c.token+skey" xs12>
																			<v-layout row wrap>
																				<v-flex xs6>
																					{{skey.replace(/_/g, ' ').toUpperCase()}}:
																				</v-flex>
																				<v-flex xs6>
																					${{c.stats[key][skey]}}
																				</v-flex>
																			</v-layout>
																		</v-flex>
																	</v-layout>
																</v-flex>
															</v-layout>
														</v-flex>
													</v-layout>
												</v-card-text>
											</v-card>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-card>
							</v-flex>
						</v-layout>
					</v-card>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12 sm12 md12 py-2>
			<div class="text-xs-center">
				<v-pagination
					v-model="currentPage"
					:length="pagesNumber"
					:total-visible="5"
					@input="updateVisible"
				></v-pagination>
			</div>
		</v-flex>
		<v-dialog 
		persistent 
		fullscreen
		v-if="editCampaign"
		hide-overlay
		transition="dialog-bottom-transition"
		v-model="dialogs.add"
		>
			<v-card>
				<v-toolbar flat dense dark color="secondary">
					<v-toolbar-title class="white--text">Campaign ID</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-toolbar-items>
					<v-divider vertical></v-divider>
						<v-btn dark flat 
							:loading="loading" 
							@click="()=>{
								dialogs.add = false
								}"
						>
						<v-icon left>close</v-icon>
						Cancel</v-btn>
					<v-divider vertical></v-divider>
						<v-btn dark flat 
							:loading="loading" 
							@click="updateGenerate()"
						>
						<v-icon left>save</v-icon>
						Generate Campaign</v-btn>
					<v-divider vertical></v-divider>
					</v-toolbar-items>
				</v-toolbar>
				<v-card-text class="pa-0">
					<v-layout row wrap>
						<v-flex xs12>
							<v-card color="secondary" class="pt-2 pb-1">
								<v-layout row wrap align-center>
									<v-flex xs11 px-2 pb-1 class="text-xs-center">
										<v-text-field
											label="Token"
											readonly
											v-model="editCampaign.token"
											solo-inverted
											suffix="Token"
											:loading="tokenLoading"
											disabled
											light
											hide-details
											class="tokenField"
											color="white"
											background-color="primary"
										></v-text-field>
									</v-flex>
									<v-flex xs1>
										<v-btn color="primary" 
										v-clipboard:copy="editCampaign.token"
                    v-clipboard:success="clipboardSuccessHandler"
                    v-clipboard:error="clipboardErrorHandler"
										icon large>
											<v-icon>file_copy</v-icon>
										</v-btn>
									</v-flex>
									<v-flex xs12 px-2 pb-1 class="text-xs-center">
										<v-text-field
											label="Campaign Name"
											v-model="editCampaign.name"
											hide-details
											solo
										></v-text-field>
									</v-flex>
								</v-layout>
							</v-card>
						</v-flex>
						<v-flex xs12 py-2>
							<v-layout row wrap>
								<v-flex xs4 px-2>
									Campaign ID
									<v-autocomplete
										:items="campaignids"
										v-model="editCampaign.campaignid"
										label="Select a campaign"
										return-object
										solo
										clearable
										hide-details
										:loading="loading"
										:append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
										@click:append-outer="addCampaignD = true"
									></v-autocomplete>
									<v-dialog v-model="addCampaignD" persistent max-width="290">
										<v-card>
											<v-card-title class="headline">You want to add a Campaign?</v-card-title>
											<v-card-text>
												<v-layout row wrap>
													<v-flex xs12>
														<v-text-field
															label="Source"
															required
															v-model="newCampaign"
														></v-text-field>
													</v-flex>
												</v-layout>
											</v-card-text>
											<v-card-actions>
												<v-spacer></v-spacer>
												<v-btn color="red darken-1" flat @click="addCampaignD = false">Cancel</v-btn>
												<v-btn :disabled="!newCampaign" color="green darken-1" flat @click="addCampaignID()">add</v-btn>
											</v-card-actions>
										</v-card>
									</v-dialog>
								</v-flex>
								<v-flex xs4 px-2>
									Source
									<v-autocomplete
										:items="referrers"
										v-model="editCampaign.source"
										label="Select a source"
										return-object
										solo
										clearable
										hide-details
										:loading="loading"
										:append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
										@click:append-outer="addSourceD = true"
									></v-autocomplete>
									<v-dialog v-model="addSourceD" persistent max-width="290">
										<v-card>
											<v-card-title class="headline">You want to add a Source?</v-card-title>
											<v-card-text>
												<v-layout row wrap>
													<v-flex xs12>
														<v-text-field
															label="Source"
															required
															v-model="newSource"
														></v-text-field>
													</v-flex>
												</v-layout>
											</v-card-text>
											<v-card-actions>
												<v-spacer></v-spacer>
												<v-btn color="red darken-1" flat @click="addSourceD = false">Cancel</v-btn>
												<v-btn :disabled="!newSource" color="green darken-1" flat @click="addSource()">add</v-btn>
											</v-card-actions>
										</v-card>
									</v-dialog>
								</v-flex>
								<v-flex xs4 px-2>
									Company Code
									<v-autocomplete
										:items="companycodes"
										v-model="editCampaign.companycode"
										label="Select a company code"
										return-object
										solo
										clearable
										hide-details
										:loading="loading"
									></v-autocomplete>
								</v-flex>
								<v-flex xs4 px-2>
									Facebook Pixel
									<v-autocomplete
										:items="facebookpixels"
										v-model="editCampaign.facebookpixel"
										label="Select a Facebook Pixel"
										return-object
										solo
										clearable
										hide-details
										:loading="loading"
										:append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
										@click:append-outer="addFB = true"
									></v-autocomplete>
									<v-dialog v-model="addFB" persistent max-width="290">
										<v-card>
											<v-card-title class="headline">You want to add a FACEBOOK Pixel?</v-card-title>
											<v-card-text>
												<v-layout row wrap>
													<v-flex xs12>
														<v-text-field
															label="Pixel"
															required
															v-model="newFB"
														></v-text-field>
													</v-flex>
												</v-layout>
											</v-card-text>
											<v-card-actions>
												<v-spacer></v-spacer>
												<v-btn color="red darken-1" flat @click="addFB = false">Cancel</v-btn>
												<v-btn :disabled="!newFB" color="green darken-1" flat @click="addFBF()">add</v-btn>
											</v-card-actions>
										</v-card>
									</v-dialog>
								</v-flex>
								<v-flex xs4 px-2>
									Snapchat Pixel
									<v-autocomplete
										:items="snapchatpixels"
										v-model="editCampaign.snapchatpixel"
										label="Select a Snapchat Pixel"
										return-object
										solo
										clearable
										hide-details
										:loading="loading"
										:append-outer-icon="`${(( userRole == 'admin') ? 'add' : '')}`"
										@click:append-outer="addSC = true"
									></v-autocomplete>
									<v-dialog v-model="addSC" persistent max-width="290">
										<v-card>
											<v-card-title class="headline">You want to add a SNAPCHAT Pixel?</v-card-title>
											<v-card-text>
												<v-layout row wrap>
													<v-flex xs12>
														<v-text-field
															label="Pixel"
															required
															v-model="newSC"
														></v-text-field>
													</v-flex>
												</v-layout>
											</v-card-text>
											<v-card-actions>
												<v-spacer></v-spacer>
												<v-btn color="red darken-1" flat @click="addSC = false">Cancel</v-btn>
												<v-btn :disabled="!newSC" color="green darken-1" flat @click="addSCF()">add</v-btn>
											</v-card-actions>
										</v-card>
									</v-dialog>
								</v-flex>
								<v-flex xs4 px-2>
									Language
									<v-autocomplete
										:items="languages"
										v-model="editCampaign.language"
										label="Select a language"
										return-object
										solo
										clearable
										hide-details
										:loading="loading"
									></v-autocomplete>
								</v-flex>
								<v-flex xs4 px-2>
									Type
									<v-autocomplete
										:items="['organic', 'paid']"
										v-model="editCampaign.type"
										label="Select a type"
										return-object
										solo
										clearable
										hide-details
										:loading="loading"
									></v-autocomplete>
								</v-flex>
							</v-layout>
							<v-layout row wrap pa-2>
								<v-expansion-panel expand>
									<v-expansion-panel-content v-for="(p, l) in editCampaign.pages" :key="l" class="primary elevation-2 text--white pa-0">
										<div slot="header" class="primary text--white pa-0">
											<v-layout row wrap align-center pa-0>
												<v-flex xs1>
													<v-btn small icon @click="removepage(l)" dark>
														<v-icon>close</v-icon>
													</v-btn>
												</v-flex>
												<v-flex align-center xs11 class="pageName subheadline" >
													{{ p.replace('_', ' ').toUpperCase() }}
													<div v-if="editCampaign.stats && editCampaign.stats[p] && editCampaign.stats[p].total">
														Total: ${{editCampaign.stats[p].total}}
													</div>
												</v-flex>
											</v-layout>
										</div>
										<v-card>
											<v-card-text>
												<v-layout v-if="editCampaign[p]" row wrap>
													<v-flex xs12 mb-2>
														<v-text-field
															label="Page Link"
															v-model="editCampaign[p].link"
															solo
															hide-details
														></v-text-field>
													</v-flex>
													<v-flex v-for="(prod, i) in editCampaign[p].products" :key="prod.name + i" xs12 mb-2>
														<v-card class=" elevation-4">
															<v-layout row wrap>
																<v-flex xs12 mb-2 pa-2 class="elevation-2 secondary">
																	<v-btn small icon @click="removeproduct(p, i)" dark>
																		<v-icon>close</v-icon>
																	</v-btn>
																	<span class="pageName">PRODUCT
																	</span> 
																	<v-autocomplete 
																		label="Product"
																		v-model="editCampaign[p].products[i].name"
																		solo
																		return-object
																		hide-details
																		clearable
																		:items="getProductList(editCampaign, p, i)"
																		@change="()=>{
																			getProductList(editCampaign, p, i)
																			getPrices(editCampaign, p, i)
																			addaPage()
																			removepage(editCampaign.pages.length-1)
																			}"
																		@load="getPrices(editCampaign, p, i)"
																	>
																	</v-autocomplete>
																</v-flex>
																<v-flex xs12>
																	<v-layout row wrap>
																		<v-flex v-for="(price, k) in editCampaign[p].products[i].prices" :key="price.text[k]" px-2  xs12>
																			<v-layout row wrap align-center>
																				<v-flex xs4>
																					Offer
																					<v-autocomplete 
																						label="Price"
																						v-model="editCampaign[p].products[i].prices[k].name"
																						solo
																						return-object
																						hide-details
																						:items="priceList[p][i]"
																						clearable
																						@change="()=>{
																							setBasePrice(editCampaign, p, i, k)
																							addaPage()
																							removepage(editCampaign.pages.length-1)
																						}"
																					>
																					</v-autocomplete>
																				</v-flex>
																				<v-flex xs2 px-2>
																					Dollar
																					<v-text-field
																						label="Base Dollar Price"
																						v-model="editCampaign[p].products[i].prices[k].price"
																						solo
																						hide-details
																						readonly
																					></v-text-field>
																				</v-flex>
																				<v-flex xs1 px-2>
																					Quantity
																					<v-text-field
																						label="Quantity"
																						v-model="editCampaign[p].products[i].prices[k].quantity"
																						solo
																						hide-details
																					></v-text-field>
																				</v-flex>
																				<v-flex xs4>
																					Text
																					<v-text-field
																						label="Text"
																						v-model="editCampaign[p].products[i].prices[k].text"
																						solo
																						hide-details
																					></v-text-field>
																				</v-flex>
																				<v-flex class="text-xs-center" xs1>
																					<v-btn small icon @click="removeaprice(p, i, k)">
																						<v-icon>close</v-icon>
																					</v-btn>
																				</v-flex>
																			</v-layout>
																		</v-flex>
																		<v-flex xs12 px-2>
																			<v-btn @click="addaPrice(p, i)" color="secondary" dark block>add a price</v-btn>
																		</v-flex>
																	</v-layout>
																</v-flex>
															</v-layout>
														</v-card>
													</v-flex>
													<v-flex xs12>
														<v-btn @click="addaProduct(p)" color="primary" dark block>add a product</v-btn>
													</v-flex>
												</v-layout>
											</v-card-text>
										</v-card>
									</v-expansion-panel-content>
								</v-expansion-panel>
								<v-flex xs12>
									<v-btn @click="addaPage()" color="error" dark block>add a page</v-btn>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-dialog>
		<v-dialog
      v-model="initloading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by ......
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import {firebase, db, auth, storageRef } from '@/fb';
import { getRandomInt, randomString, getCDate, check, uuid } from '@/customFunction';
import axios from 'axios';
import MiniStatistic from '@/components/MiniStatistic';
export default {
	components:{ MiniStatistic},
	data() {
    return {
			loading:false,
			initloading:false,
			holder:0,
			dialogs:{
				add:false,
				delete:false
			},
			addSourceD:false,
			addCampaignD:false,
			campaigns:[],
			currentPage: 1,
      pageSize: 8,
			pagesNumber:0,
			filteredCampaigns:[],
			visibleCampaigns:[],
			token:null,
			tokenLoading:false,
			campaignName:null,
			startCampaing:null,
			editCampaign:null,
			campaignids:null,
			referrers:null,
			companycodes:null,
			FullyLoadedProducts:null,
			productList:[],
			priceList:null,
			pageProductList:[],
			snapchatpixels:[],
			facebookpixels:[],
			languages:[],
			addFB:false,
			addSC:false,
			newFB:null,
			newSC:null,
			newSource:null,
			newCampaign:null,
			searchTerm:null,
			onlsnrs:[],
		}
	},
	methods:{
		getTotal(t) {
			return t.toFixed(2)
		},
		addSource(){
			db.ref(`settings/dbfilters/referrers`).once('value').then(x=>{
				db.ref('settings/dbfilters/referrers').update({
					[x.val().length]:this.newSource
				})
				.then(x=>{
					this.addSourceD = false
					this.referrers.push(this.newSource)
					this.editCampaign.source = this.newSource
				})
			})
		},
		addCampaignID(){
			db.ref(`settings/dbfilters/campaigns`).once('value').then(x=>{
				db.ref('settings/dbfilters/campaigns').update({
					[x.val().length]:this.newCampaign
				})
				.then(x=>{
					this.addCampaignD = false
					this.campaignids.push(this.newCampaign)
					this.editCampaign.campaignid = this.newCampaign
				})
			})
		},
		addFBF(){
			db.ref('facebookpixels').push(this.newFB)
			.then(x=>{
				this.addFB = false
				this.facebookpixels.push(this.newFB)
				this.editCampaign.facebookpixel = this.newFB
			})
		},
		addSCF(){
			db.ref('snapchatpixels').push(this.newSC)
			.then(x=>{
				this.addSC = false
				this.snapchatpixels.push(this.newSC)
				this.editCampaign.snapchatpixel = this.newSC

			})
		},
		addaPrice(p, i){
			if(this.editCampaign[p] 
			&& this.editCampaign[p].products 
			&& this.editCampaign[p].products[i]
			&& this.editCampaign[p].products[i].prices
			) {
				this.editCampaign[p].products[i].prices.push(
					{
						name:{},
						price:0,
						quantity:1,
						text:''
					}
				)
			}
			this.addaPage()
			this.removepage(this.editCampaign.pages.length-1)
		},
		addaProduct(p) {
			if(this.editCampaign.pages && this.editCampaign.pages.length > 0) {
				if(this.editCampaign[p].products)
				this.editCampaign[p].products.push({
					name:{},
					prices:[{
						name:{},
						price:0,
						quantity:1,
						text:''
					}]
				})
			}
			this.addaPage()
			this.removepage(this.editCampaign.pages.length-1)
		},
		addaPage(){
			if(this.editCampaign.pages && this.editCampaign.pages.length > 0) {
				let pageName = `page_${this.editCampaign.pages.length+1}`
				this.editCampaign.pages.push(pageName)
				this.editCampaign[pageName] = {}
				this.editCampaign[pageName].products = []
				this.editCampaign[pageName].products.push({
					name:{},
					prices:[{
						name:{},
						price:0,
						quantity:1,
						text:''
					}]
				})
				return this.editCampaign.pages.length+1
			}
			// else
			// this.editCampaign.pages = []
			// this.editCampaign.pages.push(`page_${this.editCampaign.pages.length+1}`)
		},
		getProductList(editCampaign, p, i){
			if(!p && !i) return []
			if(!this.pageProductList) this.pageProductList = {}
			if(!this.pageProductList[p]) this.pageProductList[p] = []
			this.pageProductList[p][i] = this.productList
			this.getPrices(editCampaign, p, i)
			return this.pageProductList[p][i]
		},
		genToken(){
			return this.token = `${randomString(14, 'aA#')}`
		},
		
		addCampaign(){
			// this.dialogs.add = true
			console.log('s')
			this.loading = true
			this.editCampaign = {}
			let t = this.genToken()
			this.editCampaign.token = t
			let pageName = `page_1`
			this.editCampaign.pages = []
			this.editCampaign.date = getCDate()
			this.editCampaign.pages.push(pageName)
			this.editCampaign[pageName] = {}
			this.editCampaign[pageName].products = []
			this.editCampaign[pageName].products.push({
				name:{},
				prices:[{
					name:{},
					quantity:1,
					price:0,
					text:''
				}]
			})
			db.ref(`adCampaigns/${this.editCampaign.token}`)
			.update(this.editCampaign)
			.then(x=>{
				this.getCampaigns()
				.then(x=>{
					this.loading = false
					this.editCampaign = this.campaigns.filter(x=>x.token == t)[0]
					this.dialogs.add = true
				})
			})
		},
		getPagesNumber(){
      if (this.filteredCampaigns.length % this.pageSize == 0) {
        this.pagesNumber = parseInt(this.filteredCampaigns.length / this.pageSize)
      } else {
        this.pagesNumber = parseInt(this.filteredCampaigns.length / this.pageSize) + 1
      }
		},
		async updateVisible() {
			if(this.onlsnrs.length>0){
				(async rmvLsnrs => {
					for (let k = 0; k < this.onlsnrs.length; k++) {
						const lsner = this.onlsnrs[k];
						await db.ref(`adCampaigns/${lsner.token}`).off('value', lsner.l)
					}
				})()
			}
			this.visibleCampaigns = this.filteredCampaigns.slice((this.currentPage -1) * this.pageSize, ((this.currentPage -1) * this.pageSize) + this.pageSize);
			(async addlsnrs => {
				for (let i = 0; i < this.visibleCampaigns.length; i++) {
					const c = this.visibleCampaigns[i];
					let onlsnr = await db.ref(`adCampaigns/${c.token}`).on('value', x=>{
						let camp = x.val()
						if(camp.token){
							let jindex = this.visibleCampaigns.findIndex(ca=> ca.token == camp.token)
							this.visibleCampaigns.splice(jindex, 1, camp)
						}
					})
					this.onlsnrs.push({
						l:onlsnr,
						token:c.token
					})
				}
			})()
      this.loading = false
		},
		selectForEditing(c){
			this.editCampaign = this.campaigns.filter(x=> x.token == c.token)[0]
			this.dialogs.add = true
		},
		duplicate(c){
			this.editCampaign = this.campaigns.filter(x=> x.token == c.token)[0]
			this.editCampaign.token = this.genToken()
			this.editCampaign.date = getCDate()
			this.dialogs.add = true
			if(this.editCampaign.clicks) this.editCampaign.clicks = 0
			if(this.editCampaign.stats) this.editCampaign.stats = null
			if(this.editCampaign.total) this.editCampaign.total = 0
			if(this.editCampaign.last) this.editCampaign.last = null
			if(this.editCampaign.leads) this.editCampaign.leads = 0
			if(this.editCampaign.facebookpixel) this.editCampaign.facebookpixel = null
			if(this.editCampaign.snapchatpixel) this.editCampaign.snapchatpixel = null
			if(this.editCampaign.type) this.editCampaign.type = null
			this.editCampaign.name = this.editCampaign.name + ' - Copy'
		},
		getCampaigns(){
			return 	db.ref(`adCampaigns`)
			.startAt(this.startCampaing)
			.once('value')
			.then(x=>{
				this.campaigns = []
				for (const key in x.val()) {
					if (x.val().hasOwnProperty(key)) {
						const c = x.val()[key];
						if(c.token)
						this.campaigns.push(c)
					}
				}
				this.visibleCampaigns = this.campaigns
				this.filteredCampaigns = this.campaigns
				this.sortByDate()
				this.getPagesNumber()
				this.updateVisible()
				return this.campaigns
			})
		},
		filterCampaigns(){
			this.filteredCampaigns = this.campaigns
			.filter(x=>{
				if(!this.searchTerm) return x
				for (const key in x) {
					if (x.hasOwnProperty(key)) {
						const vals = x[key];
						if(typeof vals == 'string'){
							if(vals.toLowerCase().includes(this.searchTerm.toLowerCase())) {
								return x
							}
						} 
						if(typeof vals == 'object') {
							function dive(currentKey, into, target) {
									for (var i in into) {
											if (into.hasOwnProperty(i)) {
													var newKey = i;
													var newVal = into[i];
													
													if (currentKey.length > 0) {
															newKey = currentKey + '.' + i;
													}
													
													if (typeof newVal === "object") {
															dive(newKey, newVal, target);
													} else {
															target[newKey] = newVal;
													}
											}
									}
							}
							function flatten(arr) {
									var newObj = {};
									dive("", arr, newObj);
									return newObj;
							}
							let gg = flatten(x)
							for (const skey in gg) {
								if (gg.hasOwnProperty(skey)) {
									const val = gg[skey];
									if(typeof val == 'string'){
										if(val.toLowerCase().includes(this.searchTerm.toLowerCase())) {
											return x
										}
										if(val.includes(this.searchTerm)) {
											return x
										}
									}
								}
							}
						}
					}
				}
			})
			this.getPagesNumber()
			this.updateVisible()
		},
		sortByDate(){
      this.filteredCampaigns = this.filteredCampaigns.sort(function(a,b){
        return new Date(b.date) - new Date(a.date);
      });
    },
		async getDBfilter(){
      this.campaignids = await db.ref(`settings/dbfilters/campaigns`).once('value').then(x=>x.val().map(x=> x.toUpperCase()))
      this.referrers = await db.ref(`settings/dbfilters/referrers`).once('value').then(x=>x.val())
			this.companycodes = await db.ref(`settings/dbfilters/companycodes`).once('value').then(x=>x.val().map(x=> x.toUpperCase()))
			this.languages = await db.ref(`languages`).once('value').then(x=>x.val().map(x=> x.name))
			let fb = await db.ref('facebookpixels').once('value').then(x=>x.val())
			for (const key in fb) {
				if (fb.hasOwnProperty(key)) {
					const p = fb[key];
					this.facebookpixels.push(p)
				}
			}
			let sc = await db.ref('snapchatpixels').once('value').then(x=>x.val())
			for (const key in sc) {
				if (sc.hasOwnProperty(key)) {
					const p = sc[key];
					this.snapchatpixels.push(p)
				}
			}
		},
		async loadProducts(){
			db.ref('products')
			.once('value')
			.then(x=>{
				this.FullyLoadedProducts = x.val()
				let prodArr = []
				for (const key in this.FullyLoadedProducts) {
					if (this.FullyLoadedProducts.hasOwnProperty(key)) {
						const p = this.FullyLoadedProducts[key];
						prodArr.push({
							text:p.item_name,
							value:key,
							sku:p.sku
						})
					}
				}
				this.productList = prodArr
				this.initloading = false
			})
		},
		getPrices(editCampaign, p, i) {
			if(!this.priceList) this.priceList = {}
			if(!this.priceList[p]) this.priceList[p] = []
			if(!this.editCampaign[p].products[i].name) return []
			let prices = this.FullyLoadedProducts[this.editCampaign[p].products[i].name.value]
			let pricesArr = []
			let noPush= ['item_name', 'sku', 'import_date']
			for (const key in prices) {
				if (prices.hasOwnProperty(key) && noPush.indexOf(key) == -1) {
					const val = prices[key];
					if(val && val != '')
					pricesArr.push({
						text:key.toUpperCase().replace(/_/g, ' ') + ':' + val,
						value:val
					})
				}
			}
			return this.priceList[p][i] = pricesArr
		},
		getPricesItems(editCampaign, p, i) {
			if(!this.editCampaign[p] && !this.editCampaign[p].products[i] && !this.editCampaign[p].products[i]) return []
			let prices = this.FullyLoadedProducts[this.editCampaign[p].products[i].name.value]
			let pricesArr = []
			console.log(prices)
			let noPush= ['item_name', 'sku', 'import_date']
			for (const key in prices) {
				if (prices.hasOwnProperty(key) && noPush.indexOf(key) == -1) {
					const val = prices[key];
					if(val && val != '')
					pricesArr.push({
						text:key.toUpperCase().replace(/_/g, ' '),
						value:val
					})
				}
			}
			return pricesArr
		},
		removepage(i){
			if(this.editCampaign.pages && this.editCampaign.pages.length > 0) {
				let pageName = `page_${i+1}`
				this.editCampaign.pages.splice(i, 1)
				this.editCampaign[pageName] = null
				delete this.editCampaign[pageName]
			}
		},
		removeproduct(p, i){
			if(this.editCampaign[p] && this.editCampaign[p].products){
				this.editCampaign[p].products.splice(i, 1)
			}
		},
		removeaprice(p, i, k) {
			if(this.editCampaign[p] 
			&& this.editCampaign[p].products 
			&& this.editCampaign[p].products[i] 
			&& this.editCampaign[p].products[i].prices){
				this.editCampaign[p].products[i].prices.splice(k, 1)
			}
		},
		setBasePrice(editCampaign, p, i, k) {
			if(!this.editCampaign[p].products[i].prices[k].name) return
			this.editCampaign[p].products[i].prices[k].price =
			this.editCampaign[p].products[i].prices[k].name.value
		},
		validateBeforeUpdate(campaign) {
			let val = true
			console.log(campaign)
			let keys = [
			"campaignid", "companycode", "language", "name", "source", "token", "type"
			]
			for (let i = 0; i < keys.length; i++) {
				const key = keys[i];
				if(!campaign[key] || campaign[key] == '') {
					val = false
					this.$emit('snackbarNotification', `${key} Required`, 'error')
				}
			}
      
      return val
    },
		async updateGenerate(c) {
			if(this.validateBeforeUpdate(this.editCampaign)) {
				this.loading = true
				await db.ref(`adCampaigns/${this.editCampaign.token}`)
				.update(this.editCampaign)
				.then(x=>{
					this.getCampaigns()
					this.loading = false
					this.dialogs.add = false
				});
			}
			else
				return true
		},
		clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
		},
		deleteB(c){
			this.loading = true
			console.log(c.token)
			this.loading = false
			db.ref(`adCampaigns`).update({
				[c.token]:null
			})
			.then(x=>{
				this.dialogs.delete = false
				this.getCampaigns()
				this.loading = false
			})
		},
		compareDate(c){
			if(!c.last) return false
			let lastSeen = new Date(c.last)
			let curr = new Date()
			if (lastSeen.getDate() == curr.getDate()) {
				return true
			} else {
				return false
			}
		}
	},
	props: {
    userName: {
      required: true,
      default: null
    },
    userImage: {
      required: true,
      default: ''
    },
    userRole: {
      required: true,
      default: 'user'
    },
    beta: {
      required: true,
      default: false
    },
    superAdmin: {
      required: true,
      default: false
    },
	},
	created(){
		this.initloading = true
		this.getCampaigns()
		this.getDBfilter()
		this.loadProducts()
	}
}
</script>

<style scoped>
.tokenField * {
  color:white !important;
}
.pageName {
  color:white !important;
}
</style>

